import { Modal, TextField } from "@shopify/polaris";
import React, { useCallback, useState } from "react";
import { useMutation } from "@apollo/react-hooks";

import { useToastContext } from "../../shared/ToastContext";
import { useAmazonIdeaCtx } from "../context";
import { UPDATE_KPI_FOR_AMAZON_IDEA } from "../../../graphql/mutations/amazon-idea";
import { arrInvalid, handleError } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";

export default function AmazonIdeaUpdateKPI({ open, onClose, node, ids }) {
    const [state, setState] = useState(node?.kpi ? node.kpi + "" : "");
    const [setDelay] = useTimeout();
    const { setNotify, toggleToast } = useToastContext();
    const { refetch } = useAmazonIdeaCtx();

    const [updateKPI, { loading }] = useMutation(UPDATE_KPI_FOR_AMAZON_IDEA, {
        onCompleted: () => {
            setNotify({
                msg: "Update KPI for amazon idea successfully",
                err: false,
            });

            onClose();
            setDelay(() => {
                refetch && refetch();
            }, 1500);
        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });

        updateKPI({
            variables: {
                ids,
                kpi: Number(state),
            },
        });
    }, [ids, state, updateKPI, toggleToast, setNotify]);

    return (
        <Modal
            title="Update Amazon Idea KPI"
            open={open}
            onClose={onClose}
            secondaryActions={[
                { content: "Cancel", onAction: onClose, loading },
            ]}
            primaryAction={{ content: "Submit", onAction: handleSubmit }}
            sectioned
        >
            <TextField
                label="KPI"
                value={state}
                onChange={(value) => setState(value)}
                placeholder="Enter KPI"
                type="number"
                step="0.1"
            />
        </Modal>
    );
}
